import styled, { createGlobalStyle } from 'styled-components'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'

export const Thumbnail = styled.div<{ src: string }>`
  background-image: url(${({ src }) =>
    src && src !== ''
      ? `${src}`
      : 'https://res.cloudinary.com/ninety-seconds/image/upload/v1691662244/-placeholders/illustration-generic-project-image-wide.jpg'});
  background-position: center;
  background-size: cover;
  width: 3.5rem;
  height: 2.5rem;
  border-radius: 0.25rem;
  margin-right: 0.625rem;
  min-width: 3.5rem;
`
export const ProjectName = styled.a`
  max-width: 12rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    color: ${colors.black1};
  }
`
export const TableWrapper = styled.div`
  overflow-x: auto;
  overflow-y: clip;
  margin-left: -0.75rem;
  margin-bottom: 1.5rem;
`

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  color: ${colors.black1};
  min-width: 1410px;

  th {
    font-size: 11px;
    font-weight: 700;
    line-height: 0.875rem;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    padding-bottom: 1rem;
    border-bottom: 1px solid #ededed;
    cursor: pointer;

    &:first-child {
      padding-left: 12px;
    }
  }

  td {
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5rem;
    white-space: nowrap;
  }

  .thumbnail {
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.625rem;
  }

  .status {
    font-size: 0.625rem;
    font-weight: 700;
    line-height: 0.875rem;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    border-top-right-radius: 40px;
    border-bottom-right-radius: 40px;

    &.initial.interest {
      color: #e59f36;
    }
    &.signed {
      color: #3d7af1;
    }
    &.multi-Quote {
      color: #3d7af1;
    }
    &.lost {
      color: #ee5a5a;
    }
  }

  .status-header {
    cursor: pointer;

    &.reverse {
      svg {
        transform: rotate(180deg);
      }
    }
    &.blank {
      svg {
        visibility: hidden;
      }
    }
    svg {
      margin-left: 1px;
      margin-bottom: 0.25rem;
    }
  }

  .price {
    font-weight: 700;
  }

  .separator {
    height: 1rem;
  }

  .burger {
    cursor: pointer;
    position: relative;
    max-width: 2.25rem;
    display: none;
  }

  .item-separator {
    height: 0.75rem;
  }

  .item {
    height: 3.5rem;
    border-radius: 2.5rem;

    &:hover {
      background: white;
    }

    td:first-child {
      padding-left: 1rem;
      border-top-left-radius: 40px;
      border-bottom-left-radius: 40px;
    }

    td:last-child {
      padding: 0.25rem 0 0 1rem;
      border-top-right-radius: 40px;
      border-bottom-right-radius: 40px;
    }
  }

  tr:nth-last-child(2) {
    .popup-menu {
      top: -4rem;
    }
  }
`
export const ProjectWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`
export const PopupMenu = styled.div`
  background: ${colors.black1};
  border-radius: 0.5rem;
  z-index: 2;
  position: absolute;
  right: 1.38rem;
  top: 3rem;
  overflow: hidden;
  min-width: 6.875rem;
  width: max-content;
`
export const Item = styled.div<{ icon: string }>`
  color: ${colors.white};
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1.125rem;
  height: 42px;
  display: flex;
  border-bottom: 1px solid ${colors.black3};
  background: url(${({ icon }) => icon}) no-repeat left;
  padding: 0 1rem 0 2.75rem;
  justify-content: left;
  background-size: 16px 16px;
  background-position: 16px;
  align-items: center;
  cursor: pointer;

  &:last-child {
    border: none;
  }
`
export const ReactToolTipStyles = createGlobalStyle`
  .__react_component_tooltip {
    && {
      background: rgba(32, 32, 32, 0.8);
      backdrop-filter: blur(12px);
      border-radius: 8px;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      padding: 8px 12px;

      &::after {
        display: none;
      }

      &.show {
        opacity: 1;
      }
    }
  }
`
export const ToolTipWrapper = styled.div`
  border-radius: 0.5rem;
  background: rgba(30, 30, 33, 0.8);
  backdrop-filter: blur(0.75rem);
  color: white;
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  line-height: 1.5rem;

  span {
    color: white;
  }
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/BrandOrderListNew/BrandOrderListNew.style.tsx